// extracted by mini-css-extract-plugin
export default {"root":"A2Zb5X","debugBorder":"RTJmsL"};